module.exports=[
      {"case": "c47",
       "date": "febrero 1967",
       "location": "Cajón del Río",
       "group": "chorti",
       "killed": 14,
       "x": 4,
       "y": 40,
       "textSize": {"mobile":11,"desktop":12},
       "width": {"mobile":45,"desktop":70},
       "xAlign": "right",
       "yAlign": "top",
       "text": "“Muchos de aquí están [todavía] en Honduras. Casi la mitad de la aldea se fueron.” —Sobreviviente",
       "animationIndex": 1
      },
      {"case": "c1004",
       "date": "noviembre 1966",
       "location": "Río Hondo",
       "group": "chorti",
       "killed": 61,
       "x": -2,
       "y": -10,
       "textSize": {"mobile":11,"desktop":12},
       "width": {"mobile":38,"desktop":70},
       "xAlign": "left",
       "yAlign": "bottom",
       "text": "Los soldados los rociaron con gasolina y comenzaron a lanzarles bolas de papel con fuego. Las víctimas fueron quemadas vivas.",
       "animationIndex": 1
      },
      {"case": "c9",
       "date": "mayo 1978",
       "location": "Panzós",
       "group": "qeqchi",
       "killed": 53,
       "x": -5,
       "y": 0,
       "textSize": {"mobile":11,"desktop":12},
       "width": {"mobile":80,"desktop":120},
       "xAlign": "left",
       "yAlign": "bottom",
       "text": "“Si tierras quieren, la van a tener pero en el camposanto” —Soldado, momentos antes de la masacre.",
       "animationIndex": 2
      },
      {"case": "c10_1",
       "date": "febrero 1982",
       "location": "Río Negro",
       "group": "achi",
       "killed": 74,
       "x": 10,
       "y": -52,
       "textSize": {"mobile":11,"desktop":12},
       "width": {"mobile":42,"desktop":100},
       "xAlign": "right",
       "yAlign": "top",
       "text": "“En la comunidad antes estábamos tranquilos, después de la construcción de la presa es cuando surgieron muchos problemas.”",
       "animationIndex": 3
      },
      {"case": "c10_2",
       "date": "marzo 1982",
       "location": "Río Negro",
       "group": "achi",
       "killed": 177,
       "victimType": "women and children ",
       "x": 7,
       "y": 13,
       "textSize": {"mobile":11,"desktop":12},
       "width": {"mobile":40,"desktop":100},
       "xAlign": "right",
       "yAlign": "bottom",
       "text": "“Ahí perdí mi familia, pues, mi hermano, esposa, sobrinos, suegra, cuñado, comadres, tías, todos ahí ... nadie se quedó en la aldea, nos fuimos a la montaña ... quedamos abandonados, sin espíritu.”",
       "animationIndex": 3
      },
      {"case": "c18",
       "date": "julio 1982",
       "location": "San Francisco",
       "group": "chuj",
       "killed": 350,
       "x": 10,
       "y": -93,
       "textSize": {"mobile":11,"desktop":12},
       "width": {"mobile":60,"desktop":100},
       "xAlign": "right",
       "yAlign": "top",
       "text": "Después de haber matado a nuestras señoras, sacaron nuestros hijos, chiquitos de diez años, ocho, cinco y cuatro años, nomás los agarraban las patas y los giman y los somatan en los horcones de las casas y como quedan pedaceados los cerebros de los chiquitos como masa de maíz. Yo tenía seis hijos, todos murieron ... también mi esposa. Ninguno quedó vivo.”",
       "animationIndex": 4,
       "double": true
      },
      {"case": "c18",
       "date": "julio 1982",
       "location": "San Francisco",
       "group": "chuj",
       "killed": 350,
       "x": 10,
       "y": -50,
       "textSize": {"mobile":11,"desktop":12},
       "width": {"mobile":70,"desktop":100},
       "xAlign": "right",
       "yAlign": "top",
       "text": "Una vez que los soldados concluyeron la masacre, pusieron al fuego la carne de los bueyes que habían destazado y comieron, bebieron y bailaron con la música de las radio-grabadoras que robaron de las casas. Antes de marcharse, prendieron fuego a la aldea.",
       "animationIndex": 4,
       "second": true
      }
]